// const DownloadAssets = async (url, filename) => {
//     if (!url) {
//       console.error('No URL provided for download');
//       return;
//     }
  
//     try {
//       const response = await fetch(url, {
//         method: 'GET',
//         mode: 'cors', // or 'no-cors' if the server doesn't support CORS
//         headers: {
//           'Access-Control-Allow-Origin': '*',
//         },
//         credentials: 'same-origin'
//       });
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const blob = await response.blob();
//       const blobUrl = window.URL.createObjectURL(blob);
      
//       // Get file extension from URL or default to .pdf
//       const fileExtension = url.split('.').pop().toLowerCase() || 'pdf';
//       const downloadFilename = `${filename || 'download'}.${fileExtension}`;
      
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = downloadFilename;
//       document.body.appendChild(link);
//       link.click();
      
//       // Cleanup
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (error) {
//       console.error('Error downloading file:', error);
//     }
//   };
  
//   export default DownloadAssets;

const DownloadAssets = async (url, filename) => {
    if (!url) {
      console.error('No URL provided for viewing');
      return;
    }
  
    try {
      // Simple approach - open in new tab
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error viewing file:', error);
    }
  };
  
  export default DownloadAssets;